import { Component, Children } from 'react';
import { c as _defineProperty } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import json2mq from 'json2mq';
import MediaQueryList from './MediaQueryList.js';

class Media extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "mediaQueryList", null);
    _defineProperty(this, "state", {
      matches: this.props.defaultMatches
    });
    _defineProperty(this, "updateMatches", () => {
      const {
        matches
      } = this.mediaQueryList;
      this.setState({
        matches
      });
      const {
        onChange
      } = this.props;
      if (onChange) {
        onChange(matches);
      }
    });
  }
  UNSAFE_componentWillMount() {
    if (typeof window !== 'object') {
      return;
    }
    const targetWindow = this.props.targetWindow || window;
    let {
      query
    } = this.props;
    if (typeof query !== 'string') {
      query = json2mq(query);
    }
    this.mediaQueryList = new MediaQueryList(targetWindow, query, this.updateMatches);
    this.updateMatches();
  }
  componentWillUnmount() {
    this.mediaQueryList.cancel();
  }
  render() {
    const {
      children,
      render
    } = this.props;
    const {
      matches
    } = this.state;
    return render ? matches ? render() : null : children ? typeof children === 'function' ? children(matches) : !Array.isArray(children) || children.length ? matches ? Children.only(children) : null : null : null;
  }
}
_defineProperty(Media, "defaultProps", {
  defaultMatches: true
});

export default Media;
